export default [
  {
    path: "/feeder/get-token",
    name: "GetToken",
    component: () => import("../../views/feeder/GetToken.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Feeder", url: "/submenu/feeder" },
        { title: "Token", active: true },
      ],
      pageTitle: "Sinkronisasi Feeder",
    },
  },
  {
    path: "/feeder/get-BiodataMahasiswa",
    name: "GetBiodataMahasiswa",
    component: () => import("../../views/feeder/GetBiodataMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Feeder", url: "/submenu/feeder" },
        { title: "Mahasiswa", active: true },
      ],
      pageTitle: "Mahasiswa",
    },
  },
  {
    path: "/feeder/get-aktivitasMahasiswaTA",
    name: "aktivitasMahasiswaTA",
    component: () => import("../../views/feeder/aktivitasMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Feeder", url: "/submenu/feeder" },
        { title: "Aktivitas Mahasiswa TA", active: true },
      ],
      pageTitle: "Aktivitas Mahasiswa TA",
    },
  },
  {
    path: "/feeder/nilai-mahasiswa",
    name: "nilaiMahasiswa",
    component: () => import("../../views/feeder/NilaiMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Feeder", url: "/submenu/feeder" },
        { title: "Nilai Mahasiswa", active: true },
      ],
      pageTitle: "Nilai Mahasiswa",
    },
  },
  {
    path: "/feeder/kerja-praktik-mahasiswa",
    name: "feeder-kerja-praktik-mahasiswa",
    component: () => import("../../views/feeder/KerjaPraktikMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Feeder", url: "/submenu/feeder" },
        { title: "Kerja Praktik Mahasiswa", active: true },
      ],
      pageTitle: "Kerja Praktik Mahasiswa",
    },
  },
  {
    path: "/feeder/matakuliah-kurikulum",
    name: "feeder-matakuliah-kurikulum",
    component: () => import("../../views/feeder/MatakuliahKurikulum.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Feeder", url: "/submenu/feeder" },
        { title: "Matakuliah Kurikulum", active: true },
      ],
      pageTitle: "Matakuliah Kurikulum",
    },
  },
];
